import { CheckIcon } from '@heroicons/react/outline';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExclamationIcon, IconContainer } from '../../icons';
import { twMerge } from 'tailwind-merge';
import { Button } from '@/lib';

interface ISuccessStatus {
  handleChangeFile: () => void;
}

export const SuccessStatus: FC<ISuccessStatus> = ({ handleChangeFile }) => {
  const [isChangeFileClicked, setChangeFileClicked] = useState(false);

  const { t } = useTranslation('data_source_edit');

  return (
    <div
      className={twMerge(
        'flex h-52 flex-col items-center justify-center gap-6 rounded-md border bg-red-50 p-6 motion-safe:transition motion-safe:duration-500 motion-reduce:transition-none',
        isChangeFileClicked ? 'border-gray-200 bg-gray-50' : 'border-green-100 bg-green-50'
      )}
    >
      {isChangeFileClicked ? (
        <>
          <IconContainer icon={ExclamationIcon} path='assets/fileuploading/exclamation.svg' />
          <p className='rounded-md text-xl font-medium text-blue-900'>{t('file.name_and_file.file_upload_input_component.cancel_upload')}</p>
          <div className='flex gap-2'>
            <Button intent='primary' className='border' onClick={handleChangeFile}>
              {t('file.name_and_file.file_upload_input_component.delete_file')}
            </Button>
            <Button intent='secondary' onClick={() => setChangeFileClicked(false)}>
              {t('file.name_and_file.file_upload_input_component.cancel')}
            </Button>
          </div>
        </>
      ) : (
        <>
          <CheckIcon className='size-8 text-green-600' />
          <p className='text-xl font-medium text-green-900'>{t('file.name_and_file.file_upload_input_component.success')}</p>
          <Button intent='primary' onClick={() => setChangeFileClicked(true)}>
            {t('file.name_and_file.file_upload_input_component.change_file')}
          </Button>
        </>
      )}
    </div>
  );
};
